import { IDropdownOption, Icon, SelectableOptionMenuItemType, getTheme } from "office-ui-fabric-react";
import * as React from "react";
import { LocalizeContextProps, withLocalize } from "react-localize-redux";
import { Logger } from "../../../services/Logger";
import { NewformaToastIntent } from "../../_base/Toast";
import "./respondCloseSubmittal.less";
import TranslatedDatePickerComponent from "../../shared/translatedDatePicker/TranslatedDatePickerComponent";
import FromAndToComponent from "../../shared/fromAndToComponent/FromAndToComponent";
import { EmailRecipients } from "../../../models/shared/FileTransferEmailFieldsDetails";
import { IPersonaProps, ITag, Label, TextField } from "office-ui-fabric-react";
import { OfficeWrapper, MailboxItem } from "../../../services/OfficeWrapper";
import { FormValidationHelpers } from "../../../helpers/FormValidationHelpers";
import { IProjectsService } from "../../../services/NewformaApi/IProjectsService";
import * as _ from "lodash";
import { KeywordListType } from "../../../models/ProjectKeywordsResponse";
import { ExpiredSessionError } from "../../../models/ExpiredSessionError";
import { ProjectHelper } from "../../../helpers/ProjectHelper";
import { ConfigurationService } from "../../../services/ConfigurationService";
import HTMLEditor from "../../shared/editor/Editor";
import { SubmittalsApiService } from "../../../services/NewformaApi/SubmittalsApiService";
import ChipPickerComponent from "../../shared/chipPicker/ChipPickerComponent";
import { DateHelper } from "../../../helpers/DateHelpers";
import AttachmentsComponent from "../../shared/attachments/AttachmentsComponent";
import { AttachmentItem } from "../../../models/shared/AttachmentList";
import { NrnServiceWrapper } from "../../../services/NrnServiceWrapper";
import ActionDropdown from "../../shared/ActionDropdown/ActionDropdown";
import { LightDarkContext } from "../../app/LightDarkProvider";

export interface RespondCloseSubmittalProps extends LocalizeContextProps {
    shouldShowSubmittalResponse: () => void;
    logger: Logger;
    updateRespondAndCloseDate: (date: Date | undefined) => void;
    respondAndCloseDate: Date | undefined;
    updateEmails: (emails: EmailRecipients) => void;
    priorEmails: EmailRecipients;
    isLoadingRecipientEmail: boolean;
    officeWrapper: OfficeWrapper;
    formValidationHelpers: FormValidationHelpers;
    mailboxItem: MailboxItem | null;
    projectsService: IProjectsService;
    selectedProject: ITag | null;
    selectedSubmittal: ITag | undefined;
    selectedAction: string | number | undefined;
    onExpiredSession: () => void;
    onFormValidationChange: (isValid: boolean) => void;
    respondAndCloseResponse: string | undefined;
    isFiling: boolean;
    updateLoadingState: (loadingPurposes: boolean) => void;
    updateKeywords: (option: IPersonaProps[], keywords: IPersonaProps[]) => void;
    onShowToast: (message: string | null, type: NewformaToastIntent) => void;
    respondAndCloseSelectedKeyword: IPersonaProps[];
    respondAndCloseKeywords: IPersonaProps[];
    updateClearValue: () => void;
    updateRespondAndCloseResponse: (text: string | undefined) => void;
    configService: ConfigurationService;
    submittalsApiService: SubmittalsApiService;
    onEmailCheck?: (value: boolean) => void;
    isFilePathInAttachmentsSupported?: boolean;
    nrnServiceWrapper: NrnServiceWrapper;
    responseAttachmentItems: AttachmentItem[];
    respondAndCloseAttachments: AttachmentItem[];
    updateRespondAndCloseAttachments: (files: AttachmentItem[]) => void;
    onActionChange: (option: IDropdownOption | undefined) => void;
}

export interface RespondCloseSubmittalState {
    date: Date | undefined;
    from: IPersonaProps[];
    to: IPersonaProps[];
    cc: IPersonaProps[];
    shouldClearEmails: boolean;
    isActionApproved: boolean;
    responseSummary: string | undefined;
    keywords: IPersonaProps[];
    selectedkeywords: IPersonaProps[];
    isLoadingKeywords: boolean;
    allowCustomKeywords: boolean;
    areToAndCCSame?: boolean;
    isToFieldChanged?: boolean;
    attachments: AttachmentItem[];
    actions: IDropdownOption[];
    isLoadingActions: boolean;
    selectedAction?: IDropdownOption;
}

class RespondCloseSubmittal extends React.Component<RespondCloseSubmittalProps, RespondCloseSubmittalState> {
    static contextType = LightDarkContext;
    declare context: React.ContextType<typeof LightDarkContext>;
    defaultState: RespondCloseSubmittalState = {
        date: undefined,
        from: [],
        to: [],
        cc: [],
        shouldClearEmails: false,
        isActionApproved: true,
        responseSummary: "",
        keywords: [],
        selectedkeywords: [],
        isLoadingKeywords: false,
        allowCustomKeywords: false,
        areToAndCCSame: false,
        isToFieldChanged: false,
        attachments: [],
        actions: [],
        isLoadingActions: true,
    };
    constructor(props: RespondCloseSubmittalProps) {
        super(props);
        this.state = this.defaultState;
    }

    async componentDidMount() {
        this.props.logger.info("Respond Close component mounted");
        if (this.props.respondAndCloseAttachments) {
            this.setState({ attachments: this.props.respondAndCloseAttachments });
        }
        if (this.props.respondAndCloseDate) {
            this.setState({ date: this.props.respondAndCloseDate });
            this.updateRespondAndCloseButtonState();
        } else {
            this.onDateChange(DateHelper.TodayDate);
        }
        if (this.props.priorEmails.to.length === 0) {
            const submittalDetails = await this.props.submittalsApiService.getSubmittalDetails(
                this.props.selectedSubmittal?.key as string,
                this.props.selectedProject?.key as string
            );
            const toEmails = submittalDetails?.from?.email ? [{ text: submittalDetails.from.email }] : [];
            this.setEmailsState("to", toEmails);
            this.props.updateEmails({
                to: toEmails,
                cc: this.props.priorEmails.cc,
                from: [],
            });
        }
        document.querySelector(".submittalReviewResponseComponent")?.scrollTo({
            top: 0,
            behavior: "auto",
        });

        if (this.props.selectedProject) {
            await this.getActions(this.props.selectedProject.key, this.props.selectedProject.name);
            if (this.props.selectedAction) {
                this.setState(
                    { selectedAction: this.state.actions.find((action) => action.key === this.props.selectedAction) },
                    () => {
                        this.updateRespondAndCloseButtonState();
                    }
                );
            }
        }

        if (this.props.selectedProject && this.props.respondAndCloseSelectedKeyword.length === 0) {
            await this.getKeywords(this.props.selectedProject.key, this.props.selectedProject.name);
        } else if (this.props.respondAndCloseSelectedKeyword && this.props.respondAndCloseKeywords) {
            this.setState({
                selectedkeywords: this.props.respondAndCloseSelectedKeyword,
                keywords: this.props.respondAndCloseKeywords,
            });
        }

        this.setEmailsState("to", this.props.priorEmails.to);
        this.setEmailsState("cc", this.props.priorEmails.cc);
        if (this.props.respondAndCloseResponse) {
            this.setState({ responseSummary: this.props.respondAndCloseResponse });
        }
    }
    async componentWillUnmount() {
        this.props.updateRespondAndCloseAttachments(this.state.attachments);
    }

    private async getKeywords(projectNrn: string, projectName: string): Promise<void> {
        this.props.logger.info(`Loading keywords in forward submittal for selected project: ${projectName}`);
        this.setState({ isLoadingKeywords: true });
        this.props.updateLoadingState(true);
        try {
            const keywordsResponse = await this.props.projectsService.getProjectKeywords(
                projectNrn,
                KeywordListType.SubmittalKeyword
            );
            const sortedKeywords = ProjectHelper.sortKeywords(keywordsResponse);
            const keywords: IPersonaProps[] = sortedKeywords.map((keyword) => ({
                text: keyword.name,
                data: keyword,
            }));
            this.setState({ keywords, allowCustomKeywords: keywordsResponse.allowCustom });
        } catch (error) {
            if (ExpiredSessionError.isInstanceOf(error)) {
                this.props.onExpiredSession();
                return;
            }

            this.props.logger.error("ForwardSubmittalComponent Error loading keywords", error);

            this.clearKeywords();
            this.props.onShowToast(this.props.translate("SUBMITTALS.LOADING_KEYWORDS_FAILED") as string, "error");
        } finally {
            this.setState({ isLoadingKeywords: false });
            this.props.updateLoadingState(false);
        }
    }

    private clearKeywords(): void {
        this.setState({
            keywords: [],
            selectedkeywords: [],
        });
    }

    private onToChange(items?: IPersonaProps[]): void {
        this.setState(
            {
                to: items || [],
                shouldClearEmails: false,
            },
            () => {
                this.setState({ isToFieldChanged: true });
                this.props.updateEmails({ to: this.state.to, cc: this.state.cc });
                this.updateRespondAndCloseButtonState();
            }
        );
    }

    private onCcChange(people: IPersonaProps[]): void {
        this.setState(
            {
                cc: people || [],
                shouldClearEmails: false,
            },
            () => {
                this.props.updateEmails({ to: this.state.to, cc: this.state.cc });
                this.updateRespondAndCloseButtonState();
            }
        );
    }

    private onCCAndToComparison(areToAndCCSame: boolean): void {
        this.setState({ areToAndCCSame });
        this.props.onEmailCheck?.(areToAndCCSame);
    }

    private onFromChange(people: IPersonaProps[]): void {
        this.setState({ from: people });
    }

    private onBackButtonClicked(): void {
        this.props.updateEmails({ to: this.state.to, cc: this.state.cc });
        this.props.updateRespondAndCloseResponse(this.state.responseSummary);
        this.props.updateClearValue();
        this.props.shouldShowSubmittalResponse();
        this.props.updateRespondAndCloseAttachments(this.state.attachments);
    }

    private onDateChange(date: Date | undefined): void {
        this.setState({ date: date });
        this.updateRespondAndCloseButtonState();
        this.props.updateRespondAndCloseDate(date);
    }

    private updateRespondAndCloseButtonState = () => {
        const isFormValid = this.isFormValid();
        this.props.onFormValidationChange(isFormValid);
    };

    private isFormValid(): boolean {
        const { to, date, cc } = this.state;
        const isCcValid = _.isEmpty(cc) || this.props.formValidationHelpers.areAssigneesValid(cc, true);
        const isValid = !!(
            _.size(to) &&
            date !== undefined &&
            this.props.formValidationHelpers.areAssigneesValid(to, true) &&
            isCcValid &&
            !!this.state.selectedAction
        );
        return isValid;
    }

    private setEmailsState(key: keyof EmailRecipients, emails?: IPersonaProps[]): void {
        if (_.size(emails)) {
            this.setState((prevState) => ({
                ...prevState,
                [key]: emails || [],
            }));
        }
    }

    private onRemarksChange(responseSummary?: string): void {
        this.props.updateRespondAndCloseResponse(responseSummary);
        this.setState({ responseSummary });
    }

    private onKeywordsChanged(option: IPersonaProps[]): void {
        this.setState({ selectedkeywords: option });
        this.props.updateKeywords(option, this.state.keywords);
        this.updateRespondAndCloseButtonState;
    }

    private onAttachmentsUpdated = (files: AttachmentItem[]): void => {
        this.setState({
            attachments: files,
        });
        this.props.updateRespondAndCloseAttachments(files);
        document.querySelector(".submittalReviewResponseComponent")?.scrollTo({
            top: document.querySelector(".submittalReviewResponseComponent")?.scrollHeight,
            behavior: "auto",
        });
    };

    private async getActions(projectNrn: string, projectName: string): Promise<void> {
        this.props.logger.info(`Loading actions in forward submittal for selected project: ${projectName}`);
        this.setState({ isLoadingActions: true });
        this.props.updateLoadingState(true);
        try {
            const keywordsResponse = await this.props.projectsService.getProjectKeywords(
                projectNrn,
                KeywordListType.SubmittalActions
            );

            const dropdownOptions: IDropdownOption[] = [];
            const addOptions = (
                labelKey: string,
                labelText: string,
                type: string,
                disabled = false,
                tooltip?: string
            ) => {
                const items = keywordsResponse.items.filter((x) => x.type === type);
                if (items.length === 0) {
                    return;
                }

                dropdownOptions.push({
                    key: labelKey,
                    text: labelText,
                    itemType: SelectableOptionMenuItemType.Header,
                });

                items.forEach((item) => {
                    dropdownOptions.push({
                        key: item.name,
                        text: item.name,
                        disabled,
                        data: tooltip ? { tooltip } : undefined,
                    });
                });
            };

            addOptions(
                "ApproveKey",
                String(this.props.translate("SUBMITTALS.RESPOND_CLOSE.ACTION_APPROVE")),
                "respondAndCloseApprove"
            );
            addOptions(
                "NoActionTakenKey",
                String(this.props.translate("SUBMITTALS.RESPOND_CLOSE.ACTION_NO_ACTION_TAKEN")),
                "respondAndCloseNoActionTaken"
            );
            addOptions(
                "RejectedKey",
                String(this.props.translate("SUBMITTALS.RESPOND_CLOSE.ACTION_REJECT")),
                "respondAndCloseRejected"
            );
            addOptions(
                "ResubmitKey",
                String(this.props.translate("SUBMITTALS.RESPOND_CLOSE.ACTION_REJECT_RESUBMIT")),
                "respondAndCloseResubmit",
                true,
                String(this.props.translate("RFI.RESPOND_CLOSE.ACTION_HINT"))
            );

            this.setState({ actions: dropdownOptions, allowCustomKeywords: keywordsResponse.allowCustom });
        } catch (error) {
            if (ExpiredSessionError.isInstanceOf(error)) {
                this.props.onExpiredSession();
                return;
            }

            this.props.logger.error("ForwardSubmittalComponent Error loading actions", error);

            this.clearKeywords();
            this.props.onShowToast(this.props.translate("SUBMITTALS.LOADING_KEYWORDS_FAILED") as string, "error");
        } finally {
            this.setState({ isLoadingActions: false });
            this.props.updateLoadingState(false);
        }
    }

    private onActionChange(option?: IDropdownOption | undefined): void {
        this.setState({ selectedAction: option }, () => {
            this.updateRespondAndCloseButtonState();
            this.props.onActionChange(option);
        });
    }

    render(): JSX.Element {
        const theme = getTheme();

        return (
            <div className="newforma-respondCloseSubmittalContainer margin-bottom">
                <div
                    className="newforma-respondCloseBackContainer"
                    onClick={() => this.onBackButtonClicked()}
                    data-theme={this.context.themeName}
                >
                    <Icon iconName="NavigateBack" className="backIcon" data-theme={this.context.themeName} />
                    <span className="rfiText">{this.props.translate("SUBMITTALS.RESPOND_CLOSE.BACK_BUTTON")}</span>
                </div>
                <TranslatedDatePickerComponent
                    date={this.state.date}
                    label={this.props.translate("SUBMITTALS.RESPOND_CLOSE.DATE") as string}
                    disabled={this.props.isFiling}
                    onDateChange={this.onDateChange.bind(this)}
                    className="newforma-datePicker"
                    required={true}
                    showClearDateButton={false}
                />
                <FromAndToComponent
                    className={"newforma-formSpacing"}
                    isFromRequired={false}
                    isToRequired={true}
                    isCcRequired={false}
                    includeCc={true}
                    officeWrapper={this.props.officeWrapper}
                    disabled={this.props.isFiling || this.props.isLoadingRecipientEmail || !this.state.isToFieldChanged}
                    formValidationHelpers={this.props.formValidationHelpers}
                    mailboxItem={this.props.mailboxItem}
                    onFromChange={this.onFromChange.bind(this)}
                    onToChange={this.onToChange.bind(this)}
                    onCcChange={this.onCcChange.bind(this)}
                    logger={this.props.logger}
                    projectsService={this.props.projectsService}
                    disableOnError={true}
                    onError={this.props.onShowToast}
                    project={this.props.selectedProject}
                    shouldHideFrom={true}
                    shouldClearEmails={this.state.shouldClearEmails}
                    EmailRecipients={this.props.priorEmails}
                    isForwardInProgress={true}
                    onEmailCheck={this.onCCAndToComparison.bind(this)}
                    isTransferFailed={true}
                    isSubmittalRespondAndClose={true}
                />
                <ActionDropdown
                    id="submittal_action"
                    label={this.props.translate("SUBMITTALS.RESPOND_CLOSE.ACTION") as string}
                    options={this.state.actions}
                    selectedPurposeKey={this.props.selectedAction}
                    required={true}
                    onSelectionChange={this.onActionChange.bind(this)}
                    placeholder={this.props.translate("SUBMITTALS.RESPOND_CLOSE.SUGGESTION_ACTION") as string}
                    isProjectSelected={!!this.props.selectedProject}
                    isLoading={this.state.isLoadingActions}
                    disabled={this.state.isLoadingActions || this.props.isFiling}
                />
                <Label required={false}>{this.props.translate("SUBMITTALS.RESPOND_CLOSE.SUMMARY") as string}</Label>
                <HTMLEditor
                    value={this.state.responseSummary}
                    onRemarksUpdate={this.onRemarksChange.bind(this)}
                    configService={this.props.configService}
                    isFiling={this.props.isFiling}
                />
                <ChipPickerComponent
                    className="newforma-formSpacing newforma-submittalRevResponseKeywords"
                    required={false}
                    disabled={this.props.isFiling}
                    items={this.state.keywords}
                    selectedItems={this.state.selectedkeywords}
                    onSelectedItemsChanged={this.onKeywordsChanged.bind(this)}
                    label={this.props.translate("SUBMITTALS.RESPOND_CLOSE.KEYWORDS") as string}
                    allowCustomInput={this.state.allowCustomKeywords}
                />
                <AttachmentsComponent
                    attachments={this.state.attachments}
                    disabled={this.props.isFiling}
                    allowFileUploads={true}
                    onAttachmentsUpdated={this.onAttachmentsUpdated}
                    isCloudProject={false}
                    logger={this.props.logger}
                    isFilePathInAttachmentsSupported={this.props.isFilePathInAttachmentsSupported}
                    classNameForScroll={".submittalReviewResponseComponent"}
                    otherPageAttachments={this.props.responseAttachmentItems}
                    isIncludeReviewerAttachment={true}
                    customErrors={{
                        duplicateFile: String(this.props.translate("SHARED.ATTACHMENTS.DUPLICATE_NAME_SUBMITTAL")),
                        maximumFiles: String(this.props.translate("SHARED.ATTACHMENTS.MAXIMUM_FILES_SUBMITTAL")),
                    }}
                />
            </div>
        );
    }
}

export default withLocalize(RespondCloseSubmittal);
